import { render, staticRenderFns } from "./orderTracking.vue?vue&type=template&id=342be746&scoped=true&"
import script from "./orderTracking.vue?vue&type=script&lang=js&"
export * from "./orderTracking.vue?vue&type=script&lang=js&"
import style0 from "./orderTracking.vue?vue&type=style&index=0&id=342be746&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342be746",
  null
  
)

export default component.exports